module.exports = __webpack_public_path__ + "img/double_spring.prt.f864a9b1.jpg";